export default __webpack_public_path__ + "static/media/resorthotel.08979792.png";